import { Input } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.js';
import { FilterRangeWrapperProps } from './types.js';

export function PriceRangeInputs({ minName, maxName }: FilterRangeWrapperProps) {
  const { control } = useFormContext();
  return (
    <>
      <Td type="editable">
        <Controller
          name={minName}
          control={control}
          render={({ field, fieldState }) => {
            return (
              <Input
                id={minName}
                size="sm"
                type="aloftPrice"
                currencyCode="usd"
                placeholderText="Minimum"
                autoFocus
                border={'hidden'}
                borderRadius={0}
                isInvalid={fieldState.invalid}
                onClear={() => {
                  field.onChange('');
                }}
                {...field}
              />
            );
          }}
        />
      </Td>
      <Td type="editable">
        <Controller
          name={maxName}
          control={control}
          render={({ field, fieldState }) => {
            return (
              <Input
                id={maxName}
                size="sm"
                type="aloftPrice"
                currencyCode="usd"
                placeholderText="Maximum"
                border={'hidden'}
                borderRadius={0}
                autoFocus
                isInvalid={fieldState.invalid}
                onClear={() => {
                  field.onChange('');
                }}
                {...field}
              />
            );
          }}
        />
      </Td>
    </>
  );
}
